<template>
  <div class="home wrapper">
    <div class="content">
      <Header></Header>
      <Breadcrumb
        :breadcrumbs="breadcrumbs"
      ></Breadcrumb>

      <Title :title="'Orçamentos e Finanças'"></Title>

      <section class="container items-container">
        <div class="row">
          <div class="col-12 col-md-4" v-for="card in cardList">
            <Cards :title="card.title" :link="card.link" :hasButton="card.hasButton"></Cards>
          </div>
          <!-- /.col-12 col-md-3 -->
        </div>
        <!-- /.row -->
      </section>
      <!--== /.container ==-->
    </div>
    <!-- /.content -->

    <Footer></Footer>
  </div>
  <!-- /.home wrapper -->
</template>

<script>
  import Header from '../components/Header.vue';
  import Footer from '../components/Footer.vue';
  import Breadcrumb from '../components/Breadcrumb.vue';
  import Cards from '../components/generic/Cards.vue';
  import Title from '../components/generic/Title.vue';

  export default {
    name: 'orcamentos',
    components: {
      Header,
      Footer,
      Breadcrumb,
      Cards,
      Title,
    },
    data () {
      return {
        cardList: [
          {
            title: 'Orçamentos',
            link: '/orcamentosefinancas/orcamentos',
            hasButton: true
          },
          {
            title: 'Receitas da OAB',
            link: '/orcamentosefinancas/receitas/all/' + new Date().getFullYear(),
            hasButton: true
          },
          {
            title: 'Despesas',
            link: '/orcamentosefinancas/despesas/all/' + new Date().getFullYear(),
            hasButton: true
          }
        ],
        breadcrumbs: [
          {
            name: 'Início',
            link: '/'
          },
          {
            name: 'Orçamentos e Finanças',
          }
        ]
      }
    },
  };
</script>
